// 导航
const NAV_DATA = [
  {
    id: '1',
    name: '关于普顿',
    path: '/about',
    icon: 'icon-Group',
    children: [
      {
        id: '11',
        name: '精英顾问团队',
        path: '/about/group'
      },
      {
        id: '12',
        name: '总裁寄语',
        path: '/about/message'
      }
      // {
      //     id: '13',
      //     name: "普顿教育特色",
      //     path: "/about/characteristic",
      // },
    ]
  },
  {
    id: '2',
    name: '服务',
    path: '/services',
    icon: 'icon-fuwu',
    children: [
      {
        id: '21',
        name: '我们的做法',
        path: '/services/president'
      }
    ]
  },
  // {
  //     id: '3',
  //     name: "普顿特色活动",
  //     path: "/research",
  // },
  // {
  //     id: '4',
  //     name: "新闻动态",
  //     path: "/news",
  // },
  {
    id: '5',
    name: '口碑',
    path: '/case',
    icon: 'icon-shuju'
    // children: [
    //     {
    //         id: '51',
    //         name: "普顿录取成果",
    //         path: "/case/summary",
    //     },
    //     // {
    //     //     id: '52',
    //     //     name: "学生和家长感言",
    //     //     path: "/case/testimonials",
    //     // },
    // ]
  },
  {
    id: '6',
    name: '数据',
    path: '/results',
    icon: 'icon-shuju'
  },
  // {
  //     id: '6',
  //     name: "留学资料",
  //     path: "/studyAbroad",
  // },
  {
    id: '7',
    name: 'RSI',
    path: '/rsi',
    icon: 'icon-case',
    children: [
      {
        id: '71',
        name: 'RSI•MIT申请',
        path: '/rsi'
      },
      {
        id: '72',
        name: 'RSI-MIT申请流程',
        path: '/rsi/application'
      },
      {
        id: '73',
        name: 'RSI录取学生分享',
        path: '/rsi/studentsShare'
      },
      {
        id: '74',
        name: 'RSI 录取数据',
        path: '/rsi/dataRecording'
      }
    ]
  },
  {
    id: '8',
    name: '联系我们',
    icon: 'icon-youjian',
    path: '/contactUs'
  }
]

const CASE_SUMMARY_DATA = [
  {
    type_name: '特色院校',
    years: [
      {
        label: '2016',
        property: '2016'
      },
      {
        label: '2017',
        property: '2017'
      },
      {
        label: '2018',
        property: '2018'
      },
      {
        label: '2019',
        property: '2019'
      }
    ],
    list: [
      {
        id: 1,
        school_ch: '牛津大学牛津大学',
        school_en: 'aaaaaaaaaaaaaaaaaaaaaaaa',
        '2016': 8,
        '2017': 5,
        '2018': 0,
        '2019': 1
      },
      {
        id: 1,
        school_ch: '香港大学大学',
        school_en: 'aaaaaa',
        '2016': 8,
        '2017': 5,
        '2018': 0,
        '2019': 1
      }
    ]
  },
  {
    type_name: '艺术院校',
    years: [
      {
        label: '2016',
        property: '2016'
      },
      {
        label: '2017',
        property: '2017'
      },
      {
        label: '2018',
        property: '2018'
      },
      {
        label: '2019',
        property: '2019'
      }
    ],
    list: [
      {
        id: 1,
        school_ch: '艺术中心设计学院',
        school_en: 'aaaaaa aaaaaaaaaaaa',
        '2016': 8,
        '2017': 5,
        '2018': 0,
        '2019': 1
      },
      {
        id: 1,
        school_ch: '纽约大学学',
        school_en: 'aaaaaa deb',
        '2016': 8,
        '2017': 5,
        '2018': 0,
        '2019': 1
      }
    ]
  }
]

export { NAV_DATA, CASE_SUMMARY_DATA }



// WEBPACK FOOTER //
// ./src/utils/hardData.js